import React from 'react'
import { useSelector } from 'react-redux'

import { dialog } from '../../../lib/bootbox'
import { DropdownItem } from '../../DropdownItem'
import { useDeployPermissionUsers, useUserInfo } from '../../../store/user'
import { copy, renderDiagnostics } from './utils'
import { KeyCode } from '../../../constants/keyCodes'
import { useBetaFeatures } from '../../../store/features'
import { useIsHoldingKey } from '../../../lib/useIsHoldingKey'
import { featureValuesHierarchySelector } from '../../../store/features/selectors'
import { useSdkBuildInfo } from '../../../features/hostingVersions'

interface Props {
  setVisible: (visible: boolean) => void
}

export const Diagnostics: React.FC<Props> = ({ setVisible }) => {
  const user = useUserInfo()
  const hostingBuildInfo = useSdkBuildInfo()

  const features = useBetaFeatures()
  const isHoldingShift = useIsHoldingKey(KeyCode.Shift)
  const deployPermissionUsers = useDeployPermissionUsers()
  const featureValueHierarchy = useSelector(featureValuesHierarchySelector)

  if (!isHoldingShift) {
    return null
  }

  return (
    <DropdownItem
      data-test="users-management-diagnostics"
      onClick={async () => {
        setVisible(false)
        const diagnostics = await renderDiagnostics(
          user,
          features,
          featureValueHierarchy,
          hostingBuildInfo,
          deployPermissionUsers ?? undefined
        )
        copy(diagnostics)

        await dialog({
          title: 'Diagnostics info',
          message: diagnostics,
          size: 'lg',
          buttons: {
            close: {
              label: 'Close',
              className: 'btn-secondary',
              callback: () => {
                return true
              }
            },
            copy: {
              label: 'Copy to clipboard',
              className: 'btn-positive',
              callback: () => {
                copy(diagnostics)

                return false
              }
            }
          }
        })
      }}
    >
      Diagnostics
    </DropdownItem>
  )
}
